
import { FirearmAssignablePersonMetadataBase } from './firearm-assignable-person.metadata.base';


export class FirearmAssignablePersonMetadata extends FirearmAssignablePersonMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_ASSIGNABLE_PERSON_METADATA: FirearmAssignablePersonMetadata = new FirearmAssignablePersonMetadata();


